/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDohItem {
  itemImage?: string;
  itemText?: string;
  itemHeading?: string;
}

export interface IDohPage extends IDohItem {
  pageHeading?: string;
  pageText?: string;
  itemList: IDohItem[];
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class MakeApple extends Component {
  private readonly dohPage: IDohPage = {
    pageHeading: 'Play-Doh Brand How To: make a pretend apple',
    pageText:
      'A Play-Doh compound apple a day keeps the boredom at bay so try out this mini project to get their creative juices flowin’! Grab red, white, brown and green Play-Doh cans and follow along using the steps below to mold a pretend apple. What other silly pretend fruits can they mold with their Play-Doh compound colors?',

    itemList: [
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrX',
        itemText:
          'Use red Play-Doh compound to create the outside of the pretend apple. Mold it into a half-circle then press a finger into one end (this will hold the stem and leaves) then press a finger into the other end, 90 degrees from the first imprint to make the bottom of the pretend apple. Flatten a thin layer of white Play-Doh compound and mold it to fill in the flat side of their silly apple.',
        itemHeading: 'mold the Play-Doh apple',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZg',
        itemText:
          'Roll six small pieces of brown Play-Doh compound into ovals and flatten them into pretend seeds. Take a larger piece of brown Play-Doh compound and roll it into a thick cylinder to use as a stem. Green Play-Doh compound makes perfect leaves! Roll larger ovals, flatten them and carve a line down the center of each.',
        itemHeading: 'make seeds and leaves',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZf',
        itemText:
          'Arrange the pretend brown seeds on the Play-Doh apple, three on each side. Place the brown stem in the indent created in step one. On either side, place the green leaves.',
        itemHeading: 'place pieces on the Play-Doh apple',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsO',
        itemText:
          'Now that they’ve explored what they can create with Play-Doh compound, let’s see what they can add to their pretend apple to really make it stand out! What else can they add to make it even more playful? How about a smiley worm? Hand ’em some more Play-Doh cans and see what they make!',
        itemHeading: 'talk about fun and creative play!',
      },
    ],
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.dohPage.pageHeading}</h1>
          </div>
          <div className='col-md-12'>
            <div className='page-text'>
              <p>{this.dohPage.pageText}</p>
            </div>
          </div>
        </div>
        {this.dohPage.itemList.map((item) => (
          <div className='row'>
            <div className='col-md-12'>
              <table className='box'>
                <tr>
                  <td className='box-1'>
                    <img src={item.itemImage} alt={item.itemHeading} />
                  </td>
                  <td className='box-2'>
                    <h1 className='page-heading'>{item.itemHeading}</h1>
                    <p>{item.itemText}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default MakeApple;
